<script setup>
  import { useWebStore } from "~/store/web";
  const store=useWebStore();

</script>
<template>
  <carousel class="mx-auto mt-3 xl:w-3/4"
    :items-to-show="itemsToShow"
    :autoplay="store.screenSize === 'mobile'?3000:5000"
    :wrap-around="true"
    :transition="1000"
    snapAlign="start"
    >
    <Slide v-for="slide in slides" :key="slide" @click="handleClick(slide.id)" class="align-items-unset">
      <div class="grid grid-cols-1 midGrid pt-6 p15 gap20  m-3" :style="{height:height}">
        <img
          class="w-20 cursor-pointer"
          :src="slide.image === undefined?'/'+slide.id+'.webp':'/'+slide.image"
          :alt="slide.name + ' logo'"
        />
        <h2 class="largeText m0 orangeText InterExtraBold ls-03">{{slide.title === undefined? slide.name:slide.title}}</h2>
        <p class="blackText m0">{{slide.subtitle}}</p>
      </div>
    </Slide>

    <template #addons>
      <Navigation />
    </template>
  </Carousel>
</template>
<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel'
import ImageLazy from "./ImageLazy.vue";
export default {
  name: "BannerCarousel",
  components: {
    Carousel,
    Slide,
    Navigation
  },
  props:['slides','height','wrap','itemsToShow'],
  methods:{
    handleClick(id){
      this.$emit('clickedOnSlide',id)
    }
  }
}
</script>